import { createContext, useContext } from 'react';

/**
 * Optional bridge so embeds (e.g. Agents edit playground) can open a nested
 * {@link ChatProviderWrapper} with the same API client, WebSocket facade, and
 * auth/notifications as the host shell — without a second connection or token stack.
 */
const ChatHostRuntimeContext = createContext(null);

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {{
 *   apiClient: import('axios').AxiosInstance,
 *   wsService: object | null,
 *   authStore: object | null,
 *   auth0User: object | null,
 *   notifications: { success?: Function, error?: Function } | null,
 *   openChatWithAgent?: (agent: object) => void,
 * } | null} props.value
 */
export function ChatHostRuntimeProvider({ children, value }) {
  return <ChatHostRuntimeContext.Provider value={value}>{children}</ChatHostRuntimeContext.Provider>;
}

/** @returns {import('react').ContextType<typeof ChatHostRuntimeContext>} */
export function useChatHostRuntime() {
  return useContext(ChatHostRuntimeContext);
}
